import { render } from "./vSlide.vue?vue&type=template&id=f47210e6"
import script from "./vSlide.vue?vue&type=script&lang=js"
export * from "./vSlide.vue?vue&type=script&lang=js"

import "./vSlide.vue?vue&type=style&index=0&id=f47210e6&lang=scss"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__